// extracted by mini-css-extract-plugin
export default {"jpRunning":"JP_Footer_jpRunning__gq1xS","jpCurrentDate":"JP_Footer_jpCurrentDate__iE7lg","jpFootage":"JP_Footer_jpFootage__ZqtS6","higlight":"JP_Footer_higlight__E23s+"};